import { render, staticRenderFns } from "./assessment-notes-input.vue?vue&type=template&id=1a1af79a&scoped=true&"
import script from "./assessment-notes-input.vue?vue&type=script&lang=js&"
export * from "./assessment-notes-input.vue?vue&type=script&lang=js&"
import style0 from "./assessment-notes-input.vue?vue&type=style&index=0&id=1a1af79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1af79a",
  null
  
)

export default component.exports